import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Modal from '../../../shared/modals/modal.component';
import Form from '../../../shared/forms/form.component';
import { FormikPropTypes } from '../../../shared/forms/propTypes';

const TestCustomReportQueryParamModal = ({
  formik,
  schema,
  hideModal,
  isVisible,
}) => {
  const reset = useCallback(() => {
    hideModal();
    formik.resetForm();
  }, [formik, hideModal]);

  const submitAction = useCallback(() => {
    formik.handleSubmit();
    hideModal();
    // without setTimeout it would clear formik values before submitting is performed
    setTimeout(() => formik.resetForm(), 0);
  }, [formik, hideModal]);

  return (
    <Modal
      className="edit-param-modal"
      title="Verify Query"
      closeAction={reset}
      dismissText="Cancel"
      dismissAction={reset}
      submitText="Verify"
      submitAction={submitAction}
      isVisible={isVisible}
    >
      <Form
        formik={formik}
        schema={schema}
        openForEdit
      />
    </Modal>
  );
};

TestCustomReportQueryParamModal.propTypes = {
  formik: FormikPropTypes.isRequired,
  schema: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  hideModal: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
};

export default TestCustomReportQueryParamModal;
